import { Box, Stack, Typography } from "@mui/material";
import { Gauge } from "@mui/x-charts";
import React from "react";
import appcolors from "./../../constants/Colors";

const settings = {
  width: 85,
  height: 85,
  cornerRadius: "50%",
};

function GuageCard({ data }) {
  return (
    <Stack
      gap={1.5}
      direction={"row"}
      alignItems={"center"}
      border={`1px solid ${appcolors.softGrey}`}
      borderRadius={2}
    >
      <Gauge {...settings} value={data.count} />
      <Box flexGrow={2}>
        <Typography variant="body2" color={appcolors.slateGrey}>
          {data.serviceName}
        </Typography>
        <Typography variant="body1" color={appcolors.black} fontWeight={600}>
          {data.price} SAR Earning
        </Typography>
      </Box>
    </Stack>
  );
}

export default GuageCard;
